import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 96 960 960",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M180 876h44l443-443-44-44-443 443v44Zm614-486L666 262l41.823-41.823Q725 203 750.5 203.5T793 221l43 43q17 17 17 42t-16.963 41.963L794 390ZM150.327 936q-12.889 0-21.608-8.714Q120 918.571 120 905.689v-85.627Q120 814 122 809q2-5 7-10l495-495 128 128-495 495q-5 5-10.217 7-5.218 2-10.783 2h-85.673ZM645 411l-22-22 44 44-22-22Z"
	})]
});
export default SvgEdit;
